<div class="td-wb-modal-notification">
  <h1 class="td-wb-modal-notification__header"
      translate="tdWb.modalNotification.openBanking.TITLE"></h1>
  <div class="td-wb-modal-notification__row">
    <div class="td-wb-modal-notification__left">
      <p class="td-wb-modal-notification__copy"
         translate="tdWb.modalNotification.openBanking.DESCRIPTION_I"></p>
      <p class="td-wb-modal-notification__copy"
         translate="tdWb.modalNotification.openBanking.DESCRIPTION_II"></p>
      <a class="link_ofi_open_banking_video_link"
         href="#/page/transfers/transfers-overview/entry"
         translate="tdWb.modalNotification.openBanking.START_TRANSFER"></a>
    </div>
    <div class="td-wb-modal-notification--image-container">
      <a class="td-wb-link"
         tdWbHref="link_stock_lending_video"
         target="_blank"
         rel="noopener">
        <div class="td-wb-modal-notification__video-play-container">
          <img class="td-wb-modal-notification__video-play-image"
               tdWbModalNotificationImage
               src="ofi-open-banking.svg"
               [attr.alt]="'tdWb.modalNotification.openBanking.WATCH_VIDEO_LINK' | translate">
          <div class="td-wb-modal-notification__video-play">
            <td-wb-icon iconId="play-video"
                        size="50x50" />
          </div>
        </div>
      </a>
    </div>
  </div>
</div>
